import { createFileRoute } from "@tanstack/react-router"
import { BackofficeCampaignHealth } from "modules/backoffice/components/campaigns/health"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/backoffice/campaigns/health")({
  component: BackofficeCampaignHealth,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.campaigns.health.title"),
    })
  },
})
